import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { doc, getDoc, collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from '../../index';
import { firestoreToDream } from '../../classes/Dream';


const initialState = {
  text: "",
  interpretation: "",
  dreamId: null,
  isLoading: false,
  isSaving: false,
}

export const getDream = createAsyncThunk(
  'dream/fetchDream',
  async (dreamId) => {
    const q = doc(db, "dreams", dreamId)
    const result = await getDoc(q)
    return firestoreToDream(result).toJson();
  }
)

export const saveDream = createAsyncThunk(
  'dream/createDream',
  async (args) => {
    const { dreamText, dreamInterpretation, userId } = args
    try {
      const docRef = await addDoc(collection(db, "dreams"), {
        content: dreamText,
        interpretation: dreamInterpretation,
        createdAt: Timestamp.fromDate(new Date()),
        authorId: userId
      });
      return docRef.id;
    } catch (e) {
      console.error(">>> ERROR adding document: ", e);
    }
  }
)

export const dreamSlice = createSlice({
  name: 'dream',
  initialState,
  reducers: {
    setText: (state, action) => {
      state.text = action.payload;
    },
    setInterpretation: (state, action) => {
      state.interpretation = action.payload;
    },
    setDream: (state, action) => {
      const { text, interpretation } = action.payload;
      state.text = text;
      state.interpretation = interpretation;
    },
    resetDream: (state) => {
      state.interpretation = "";
      state.text = "";
      state.dreamId = null;
      state.isLoading = false;
      state.isSaving = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveDream.pending, (state, action) => {
        state.isSaving = true;
      })
      .addCase(saveDream.fulfilled, (state, action) => {
        state.dreamId = action.payload;
        state.isSaving = false;
      })
      .addCase(getDream.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDream.fulfilled, (state, action) => {
        state.isLoading = false;

        const dream = action.payload;

        state.interpretation = dream.interpretation;
        state.text = dream.text;
        state.dreamId = dream.id;
      })
  }
})

export const { setText, setInterpretation, resetDream, setDream } = dreamSlice.actions;

export const getText = (state) => state.dream.text;
export const getIsLoading = (state) => state.dream.isLoading;
export const getIsSaving = (state) => state.dream.isSaving;
export const getInterpretation = (state) => state.dream.interpretation;
export const getDreamId = (state) => state.dream.dreamId;

export default dreamSlice.reducer;
